import { IRootState } from "../interfaces";

export const getTasks = (state: IRootState) => state.taskReducer.tasks;
export const taskLoading = (state: IRootState) => state.taskReducer.loading;

export const getTask = (state: IRootState) => state.taskReducer.task;
